import { useEffect, useState } from 'react';

import { DEFAULT_SITE_CONTENT } from '@/constants/site-content.defaults';
import { siteContentService } from '@/services/site-content.service';
import type { SiteContent } from '@/types/site-content';

let cache: SiteContent | null = null;
let loadPromise: Promise<SiteContent> | null = null;

function fetchSiteContent(): Promise<SiteContent> {
  if (cache) {
    return Promise.resolve(cache);
  }
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = siteContentService
    .getPublic()
    .then((data) => {
      cache = data;
      return data;
    })
    .catch(() => DEFAULT_SITE_CONTENT)
    .finally(() => {
      loadPromise = null;
    });

  return loadPromise;
}

export function resetPublicSiteContentCache(): void {
  cache = null;
  loadPromise = null;
}

export function useSiteContent(): { content: SiteContent; isLoading: boolean } {
  const [content, setContent] = useState<SiteContent>(() => cache ?? DEFAULT_SITE_CONTENT);
  const [isLoading, setIsLoading] = useState(() => cache === null);

  useEffect(() => {
    void fetchSiteContent().then((data) => {
      setContent(data);
      setIsLoading(false);
    });
  }, []);

  return { content, isLoading };
}
